import { cn } from "@/lib/utils";
import logoBlack from "@/assets/logo.svg";
import logoLight from "@/assets/logo-light.svg";

interface LogoProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  size?: "sm" | "md" | "lg" | "xl";
  variant?: "light" | "dark";
}

const sizeClasses = {
  sm: "h-6",
  md: "h-8",
  lg: "h-10",
  xl: "h-14",
};

export function Logo({
  size = "md",
  variant = "dark",
  className,
  alt = "Leal Chapa y Pintura",
  ...props
}: LogoProps) {
  // Use dark logo (for light backgrounds) by default
  const logoSrc = variant === "light" ? logoLight : logoBlack;

  return (
    <img
      src={logoSrc}
      alt={alt}
      className={cn(sizeClasses[size], "w-auto object-contain", className)}
      {...props}
    />
  );
}

// Icon-only version for mobile/sidebar collapsed
interface LogoIconProps extends React.SVGAttributes<SVGElement> {
  size?: "sm" | "md" | "lg";
}

const iconSizeClasses = {
  sm: "h-6 w-6",
  md: "h-8 w-8",
  lg: "h-10 w-10",
};

export function LogoIcon({
  size = "md",
  className,
  ...props
}: LogoIconProps) {
  // Always use dark fill for light theme
  const fillColor = "#111827";

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 48 48"
      fill="none"
      className={cn(iconSizeClasses[size], className)}
      {...props}
    >
      <g fill={fillColor}>
        {/* Car body silhouette */}
        <path d="M4 28c0-2.2 1.8-4 4-4h20c1.5 0 2.9.8 3.6 2l2.8 5H38c2.2 0 4 1.8 4 4v3c0 1.1-.9 2-2 2h-1.5c-.3 2-2 3.5-4 3.5s-3.7-1.5-4-3.5h-13c-.3 2-2 3.5-4 3.5s-3.7-1.5-4-3.5H8c-1.1 0-2-.9-2-2v-3c0-2.2 1.8-4 4-4H8c-1.1 0-2-.9-2-2v-1zm9 13a2 2 0 100-4 2 2 0 000 4zm22 0a2 2 0 100-4 2 2 0 000 4z"/>
        {/* Paint brush accent */}
        <path d="M38 18l3-9c.2-.7 1-1.1 1.7-.9l.4.1c.7.2 1.1 1 .9 1.7L41 19c-.2.7-1 1.1-1.7.9l-.4-.1c-.7-.2-1.1-1-.9-1.8z"/>
      </g>
    </svg>
  );
}
